// src/components/dentally/DentallyScopePendingStep.jsx
//
// Neutral placeholder for the booking step while useDentallyIntegrationScope is
// still deciding whether THIS practice has an active Dentally integration.
//
// The booking surfaces have two mutually exclusive variants (Dentally wizard vs
// the CRM form). Rendering the CRM one during the unsettled window and swapping
// it a moment later is worse than a brief placeholder: the operator starts
// filling in a form that disappears. The scope's `pending` flag is false as soon
// as the answer is knowable, so on a practice with the feature hidden this never
// renders at all.
import { Box, CircularProgress, Typography } from '@mui/material';

export default function DentallyScopePendingStep() {
  return (
    <Box
      data-testid="dentally-scope-pending"
      sx={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, py: 6,
      }}
    >
      <CircularProgress size={20} />
      <Typography variant="body2" color="text.secondary">Loading booking options…</Typography>
    </Box>
  );
}
